/**
 * @desc: 服务商查询
 * @created: 2020/4/1
 * @author:lijun
 * @version : v1.0
 */
import request from '@/plugins/http'
import qs from 'qs'

// 列表
export const getListData = params => {
  return request.get('/servicer/list', params)
}

// 新建城市服务商 渠道
export const saveService = data => {
  return request.post('/servicer/save', qs.stringify(data))
}

// 下拉服务城市接口
export const getServiceCity = params => {
  return request.get('/company/city/list', params)
}

// 查询已激活的收单机构
export const getActCompany = params => {
  return request.get('/company/actCompany', params)
}

// 根据收单机构id查询该下已激活的服务城市
export const getActCity = params => {
  return request.get('/company/city/actCity', params)
}


// 服务商号接口
export const getServiceId = params => {
  return request.get('/servicer/getSerId', params)
}

// 查看详情
export const getDetails = params => {
  return request.get('/servicer/details', params)
}

// 冻结解冻
export const serverState = data => {
  return request.put('/servicer/status', qs.stringify(data))
}

// 修改
export const serverModify = data => {
  return request.post('/servicer/modify', qs.stringify(data))
}
